/** @format **/

import { getIdSetting } from "../../../partners/config/ocr";
import { generateScreen } from "./generator";

const ocrScreens = (i18n) => ({
  ocrWithFailFallback: {
    type: "ocr",
    params: {
      hideTitle: true,
      flowName: getIdSetting.flows.fullCheck,
      onSuccess: async (store, { userData, process }) => {
        store.commit("updateOcrData", { userData });
        process();
      },
      onDeclined: async (store, { screenParams }) => {
        const { errorPath } = screenParams;
        if (screenParams.errorPath) {
          store.dispatch("next", errorPath);
          return;
        }
        store.commit("ocrSetIsOcrMethodSelected", false);
        store.dispatch("next", screenParams.nextScreenRoute);
      },
      onVerifyMaxAttemptsReached: async (store, { process, screenParams }) => {
        const { errorPath } = screenParams;
        if (screenParams.errorPath) {
          store.dispatch("next", errorPath);
          return;
        }
        store.commit("ocrSetIsOcrMethodSelected", false);
        process();
      },
      onFail: async (store, { process, screenParams }) => {
        const { errorPath } = screenParams;
        if (screenParams.errorPath) {
          store.dispatch("next", errorPath);
          return;
        }
        store.commit("ocrSetIsOcrMethodSelected", false);
        process();
      },
      conditions: [
        {
          property: "ocr.isOcrMethodSelected",
          value: true,
        },
      ],
    },
  },
  ocr: {
    type: "ocr",
    params: {
      hideTitle: true,
    },
  },
});

export const getOcrScreens = generateScreen.bind(null, ocrScreens);



// WEBPACK FOOTER //
// ./src/partners/config/screens/ocr.js